import styled from "@emotion/styled";
import ArrowDown from "@engineering/icons/arrow-down";
import ArrowUp from "@engineering/icons/arrow-up";
var ArrowStyle40 = "\n    width: 1rem;\n    height: 1rem;\n    fill: currentcolor;\n  ";
var ArrowStyle60 = "\n    width: 2rem;\n    height: 2rem;\n    fill: currentcolor;\n  ";
var StyledArrowUp = /*#__PURE__*/ styled(ArrowUp, {
    target: "ei2iz980"
})(function(param) {
    var iconSize = param.iconSize;
    return iconSize === 40 ? ArrowStyle40 : ArrowStyle60;
});
var StyledArrowDown = /*#__PURE__*/ styled(ArrowDown, {
    target: "ei2iz981"
})(function(param) {
    var iconSize = param.iconSize;
    return iconSize === 40 ? ArrowStyle40 : ArrowStyle60;
});
export { StyledArrowUp, StyledArrowDown };
